module.exports = __webpack_public_path__ + "img/bullhorn.92837b2d.svg";